import MealTypeModel from '@/modules/meal-types/models/meal-type.model';

const ANY_MEAL_TYPE: MealTypeModel = {
    id: -1,
    displayName: 'filters.any',
    name: 'any',
};

export default ANY_MEAL_TYPE;
